// O prazo que mais pesa numa perícia e como dizê-lo. Portado de `src/lib/proxima-acao.ts` (03/11, 000385),
// com a contagem de dias no dia de São Paulo (`datas.ts`): lá `new Date("AAAA-MM-DD")` era meia-noite UTC e,
// com o "hoje" à meia-noite LOCAL, a diferença saía com um dia a menos.
import { diasAte } from "./datas";
import type { Tom } from "./format";
import type { Pericia, Prazo } from "./tipos";

/** O prazo relacionado a uma perícia: o mais próximo em aberto (prazo cadastrado ou entrega do laudo). */
export function prazoRelacionado(p: Pericia, prazos: Prazo[], agora: Date = new Date()): { data: string; dias: number } | null {
  const candidatos: string[] = [];
  for (const pr of prazos) if (pr.pericia_id === p.id && !pr.cumprido) candidatos.push(pr.data);
  if (p.dataEntregaLaudo) candidatos.push(p.dataEntregaLaudo);
  const comDias = candidatos
    .map((data) => ({ data, dias: diasAte(data, agora) }))
    .filter((x): x is { data: string; dias: number } => x.dias !== null)
    .sort((a, b) => {
      const fa = a.dias < 0 ? 1 : 0;
      const fb = b.dias < 0 ? 1 : 0;
      if (fa !== fb) return fa - fb; // os futuros primeiro
      return Math.abs(a.dias) - Math.abs(b.dias);
    });
  return comDias[0] ?? null;
}

/** O prazo escrito por extenso: "-3d" obrigava a decifrar o sinal. */
export function rotuloDias(dias: number | null): string {
  if (dias === null) return "Sem prazo";
  if (dias < 0) return `Vencido há ${Math.abs(dias)} ${Math.abs(dias) === 1 ? "dia" : "dias"}`;
  if (dias === 0) return "Vence hoje";
  return `${dias} ${dias === 1 ? "dia" : "dias"}`;
}

export function tomDosDias(dias: number | null): Tom {
  if (dias === null) return "neutro";
  if (dias < 0) return "erro";
  if (dias <= 3) return "atencao";
  return "info";
}
